import { render, staticRenderFns } from "./FormTemplateSliderQuestion.vue?vue&type=template&id=b0c81f52&scoped=true&"
import script from "./FormTemplateSliderQuestion.vue?vue&type=script&lang=js&"
export * from "./FormTemplateSliderQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateSliderQuestion.vue?vue&type=style&index=0&id=b0c81f52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c81f52",
  null
  
)

export default component.exports